import type { CustomerGroupDemand } from '../../gql';

import { randNumber, randCountryCode, randWord } from '@ngneat/falso';

import { mockAssortmentDemand } from './mockAssortmentDemand';

/** Will return a mocked CustomerGroupDemand object, useful for tests etc. */
const mockCustomerGroupDemand = (
    overwrite?: Partial<CustomerGroupDemand>
): CustomerGroupDemand => {
    const baseCustomerGroupDemand: CustomerGroupDemand = {
        assortmentDemands: [
            mockAssortmentDemand(),
            mockAssortmentDemand(),
            mockAssortmentDemand(),
        ],
        customerGroupCountryCode: Array.isArray(randCountryCode())
            ? randCountryCode()[0]
            : randCountryCode(),
        customerGroupName: `${randWord({ capitalize: true })} Customer Group`,
        customerGroupNumber: randNumber({ min: 10000, max: 99999 }),
    };

    return { ...baseCustomerGroupDemand, ...overwrite };
};

export { mockCustomerGroupDemand };
